import React from "react"
import { ChevronRightIcon } from "@heroicons/react/24/solid"
import ProductBox from "./ProductBox"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import useT from "../hooks/useT"
import useAsync from "../hooks/useAsync"
import useSiteLanguage from "../hooks/useSiteLanguage"
import { ListProducts, LIST_FIELDS } from "../api"

// "You may also like" row (product.see_also)
export default function SeeAlsoHorizontal({ list, displayCount = 5 }) {
  const t = useT()
  const language = useSiteLanguage()
  const shown = (list || []).slice(0, displayCount)
  const pids = shown.map((p) => p.pid).filter(Boolean)
  // product.see_also carries no `original`, only the thumb (the cover centered
  // on a padded canvas): the list answer brings it, so the pictures sit on the
  // bottom edge as in every other row
  const { result } = useAsync(
    () => ListProducts({ page: 0, pids, items_per_page: pids.length, language, owned_only: false, fields: LIST_FIELDS }),
    [pids.join(","), language],
    { enabled: pids.length > 0 }
  )
  if (shown.length === 0) return null
  const originals = Object.fromEntries((result?.list || []).map((p) => [p.pid, p.original]))
  return (
    <section className="w-full flex flex-col items-center">
      <Typography 
        component="h2" 
        variant="h4"
      >
        {t`You may also like`}
      </Typography>
      <div className="w-full py-10 overflow-x-auto no-scrollbar">
        <div className="flex flex-row flex-nowrap gap-5 w-max mx-auto px-4 md:px-0">
          {shown.map((product) => (
            <ProductBox
              key={product.pid || product._id}
              product={originals[product.pid] ? { ...product, original: originals[product.pid] } : product}
              placement="see_also"
            />
          ))}
        </div>
      </div>
      <Button variant="link_accent" className="inline-flex items-center" href="/category/latest">
        {t`See more`}
        <ChevronRightIcon className="w-5 h-5 mt-[1px]" />
      </Button>
    </section>
  )
}
